export const m = {
    menuLists: [
        { index: 1, title: '首页', linkHref: '#page1', childList: [] },
        {
          index: 2,
          title: '解决方案',
          linkHref: '#page2',
          childList: []
        },
        { index: 3, title: '定制开发', linkHref: '#page3', childList: [
          {
          childIndex: 1,
          childTitle: '后端开发'
        },
        {
          childIndex: 2,
          childTitle: '前端开发'
        },
        {
          childIndex: 3,
          childTitle: '手机应用开发'
        },
        {
          childIndex: 4,
          childTitle: '数据库管理员'
        }
        ] },
        { index: 4, title: '技术合作', linkHref: '#page4', childList: [] },
        { index: 5, title: 'English', linkHref: '#', childList: [] }
      ]
}

